<ng-container *ngIf="(details | keyvalue)?.length then detail; else empty"></ng-container>

<ng-template #detail>
  <div>
    <pre>{{details | json}}</pre>
  </div>
</ng-template>

<ng-template #empty>
  <div>Информация отсутствует</div>
</ng-template>
